import { wsapi } from '../components/api/wsapi';
import { SignalingTransport } from './VideoCallManager';

/**
 * Adapts the existing therapy Socket.IO connection to the VideoCallManager's
 * SignalingTransport interface. The server (therapy.gateway.ts) relays each
 * `webrtc-*` event to the other members of the caller's session room, so the
 * client only needs to emit/subscribe by event name — the room scoping is
 * enforced server-side (the socket must already have `joinSession`-ed, which
 * HostSession/VisitorSession do on mount).
 */
export function createSocketSignaling(): SignalingTransport {
  const socket = wsapi();
  return {
    send: (type, payload) => {
      socket.emit(type, payload);
    },
    on: (type, handler) => {
      socket.on(type, handler);
      return () => {
        socket.off(type, handler);
      };
    },
  };
}
